import { gql, useQuery } from "@apollo/client";

const GET_TEST_QUERY = gql`
  query Query {
    getTestQuery
  }
`;

export const useTestQuery = () => {
  const { loading, error, data } = useQuery(GET_TEST_QUERY);

  return { loading, error, data: data?.getTestQuery ?? data };
};
